<template>
  <a
    :href="link"
    rel="noreferrer"
    target="_blank"
    class="transition-opacity"
    :class="{ 'opacity-0': !imageLoaded }"
  >
    <CoreImage
      class="rounded-tight w-full"
      :sizes="sizes"
      :image="image[0]"
      @load="handleLoad"
    />
    <h2
      class="font-title uppercase text-center leading-none mt-5 mb-10 text-2-mob lg:text-3-desk text-overflow-mulitline"
    >
      {{ title }}
    </h2>
  </a>
</template>

<script>
import { sizesHelper } from "@c/Core/CoreImage";

export default {
  name: "DirectoryTile",

  props: {
    title: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    image: {
      type: Array
    }
  },

  data: () => ({
    imageLoaded: false
  }),

  computed: {
    sizes() {
      return sizesHelper([["screen-xl", 3], "50vw"]);
    }
  },

  methods: {
    handleLoad() {
      this.imageLoaded = true;
      this.$emit("load");
    }
  }
};
</script>

<style scoped>
.text-overflow-mulitline {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
